import {
  FormControl,
  FormHelperText,
  FormLabel,
  Skeleton,
  TextareaProps,
} from '@mui/joy'
import { ParseKeys } from 'i18next'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParserI18nMessage } from '~/shared/lib/i18n'
import { Textarea } from './styled'

type TextareaInputProps = {
  label?: ParseKeys
  placeholder?: ParseKeys
  name: string
  skeletonShow?: boolean
} & Omit<TextareaProps, 'name' | 'slotProps'>

export function TextareaInput({
  label,
  placeholder,
  name,
  skeletonShow,
  ...inputProps
}: TextareaInputProps) {
  const { t } = useTranslation()
  const { parserI18nMessage } = useParserI18nMessage()
  return (
    <Controller
      name={name}
      defaultValue=''
      render={({ field, fieldState: { error, invalid } }) => (
        <FormControl error={invalid}>
          {label && <FormLabel>{t(label)}</FormLabel>}
          <Textarea
            size='md'
            {...inputProps}
            {...field}
            {...(placeholder ? { placeholder: t(placeholder) } : {})}
            value={field?.value || ''}
            error={invalid}
            slotProps={{
              ...(skeletonShow ? { root: { component: Skeleton } } : {}),
            }}
          />
          {invalid && (
            <FormHelperText data-testid={`error-message-${label && t(label)}`}>
              {parserI18nMessage(error?.message)}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}
